export default "__VITE_ASSET__DUQ5rMZE__"